import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { deleteMerchantAPI } from 'src/serverApi/merchants';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import permissions from 'src/constants/permissions';
import Button from 'src/components/Button';
import LinkButton from 'src/components/LinkButton';
import Modal from 'src/components/Modal';
import MerchantInfo from './MerchantInfo';
import { toast } from 'react-toastify';
import styles from './styles.module.scss';

type Props = {
  merchant: any;
  reloadMerchants: () => Promise<any>;
};

const DeleteMerchantButton: React.FC<Props> = ({ merchant, reloadMerchants }) => {
  const { organizationUeid = '', bankUeid = '' } = useParams();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const withAuthorities = useWithAuthorities([permissions.dataManagement]);

  const handleDeleteMerchantButtonClick = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDeleteAccept = async () => {
    try {
      setIsLoading(true);
      await withAuthorities(async () => {
        await deleteMerchantAPI(organizationUeid, bankUeid, merchant?.ueid);
        setIsDialogOpen(false);
        reloadMerchants();
      });
    } catch (error) {
      toast.error('Произошла ошибка при попытке удалить ТСП');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LinkButton onClick={handleDeleteMerchantButtonClick}>Удалить ТСП</LinkButton>
      <Modal
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        title="Вы действительно хотите удалить ТСП из списка?"
        content={
          <MerchantInfo
            merchant={merchant}
            tokenEmissionTimestamp={merchant?.tokenEmissionTimestamp}
          />
        }
        footer={
          <>
            <Button disabled={isLoading} onClick={handleCloseDialog} className={styles['modal-button']}>
              Отмена
            </Button>
            <Button
              variant="outlined"
              disabled={isLoading}
              onClick={handleDeleteAccept}
              className={styles['modal-button']}
            >
              Удалить
            </Button>
          </>
        }
      />
    </>
  );
};

export default DeleteMerchantButton;
